import * as dis2 from '../../dispossitions/dispossitions.const';
import { ACTIVITY_TYPE_TRAINING, ACTIVITY_TYPE_TRAINING_ID } from '../activity-type.const';
import {
    COACH_PAYMENT,
    FC_KEEPER_PAYMENT,
    MEDIATOR_PAYMENT,
    OTHER_FEE,
    SESSION_FEE,
    TRAINER_PAYMENT,
    TRAINING_FEE,
} from '../payamnets.const';

export const BASIC_MEDIATION_TRAINING_LABEL = 'Basic Mediation';
export const PEER_MEDIATION_LABEL = 'Peer Mediation';
export const REST_PRA_TRAINING_LABEL = 'Restorative Practices';
export const SKILL_BUILDING_LABEL = 'Skill Building/Workshops';
export const ADVANCE_TRAINING_LABEL = 'Advanced Training';
// export const MENTORING_LABEL = 'Mentoring';
export const CONFLICT_COUCHING_TRAINING_LABEL = 'Conflict Coaching';
// export const PROF_LERNING_COM_LABEL = 'Learning Community';
export const OTHER_TRAINING_LABEL = 'Other Training';
//
export const BASIC_MEDIATION_TRAINING_ID = '65f066bc2d71dfb4e188015e';
export const PEER_MEDIATION_ID = '65f082bc2d71dfb4e188016e';
export const REST_PRA_TRAINING_ID = '65f062bc2d71dfb4e188017e';
export const SKILL_BUILDING_ID = '65f072bc2d71dfb4e188018e';
export const ADVANCE_TRAINING_ID = '65f062bc2d71dfb4e188019e';
// export const MENTORING_ID = '65f062bc2d71dfb4e188020e';
export const CONFLICT_COUCHING_TRAINING_ID = '65f062bc2d71dfb4e188021e';
// export const PROF_LERNING_COM_ID = '65f062bc2d71dfb3e188022e';
export const OTHER_TRAINING_ID = '65f062bc2d71dfb4e188023e';

export const BASIC_MEDIATION = {
    _id: BASIC_MEDIATION_TRAINING_ID,
    label: BASIC_MEDIATION_TRAINING_LABEL,
    defaultDisposition: dis2.TR_BM_OPEN_PENDING,
    dispositions: [dis2.TR_BM_OPEN_PENDING, dis2.TR_BM_COMPLETED, dis2.TR_BM_OTHER],
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const PEER_MEDIATION = {
    _id: PEER_MEDIATION_ID,
    label: PEER_MEDIATION_LABEL,
    defaultDisposition: dis2.TR_PM_OPEN_PENDING,
    dispositions: [dis2.TR_PM_OPEN_PENDING, dis2.TR_PM_COMPLETED, dis2.TR_PM_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

export const REST_PRA = {
    _id: REST_PRA_TRAINING_ID,
    label: REST_PRA_TRAINING_LABEL,
    defaultDisposition: dis2.TR_RP_OPEN_PENDING,
    dispositions: [dis2.TR_RP_OPEN_PENDING, dis2.TR_RP_COMPLETED, dis2.TR_RP_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

export const SKILL_BUILDING = {
    _id: SKILL_BUILDING_ID,
    label: SKILL_BUILDING_LABEL,
    defaultDisposition: dis2.TR_SBW_OPEN_PENDING,
    dispositions: [dis2.TR_SBW_OPEN_PENDING, dis2.TR_SBW_COMPLETED, dis2.TR_SBW_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

export const ADVANCE_TRAINING = {
    _id: ADVANCE_TRAINING_ID,
    label: ADVANCE_TRAINING_LABEL,
    defaultDisposition: dis2.TR_AT_OPEN_PENDING,
    dispositions: [dis2.TR_AT_OPEN_PENDING, dis2.TR_AT_COMPLETED, dis2.TR_AT_OTHER],
    paymentIn: [TRAINING_FEE],
};

export const CONFLICT_COUCHING_TRAINING = {
    _id: CONFLICT_COUCHING_TRAINING_ID,
    label: CONFLICT_COUCHING_TRAINING_LABEL,
    defaultDisposition: dis2.TR_CC_OPEN_PENDING,
    dispositions: [dis2.TR_CC_OPEN_PENDING, dis2.TR_CC_COMPLETED, dis2.TR_CC_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

export const OTHER_TRAINING = {
    _id: OTHER_TRAINING_ID,
    label: OTHER_TRAINING_LABEL,
    defaultDisposition: dis2.TR_OTH_OPEN_PENDING,
    dispositions: [dis2.TR_OTH_OPEN_PENDING, dis2.TR_OTH_COMPLETED, dis2.TR_OTH_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

export const TRAINING = {
    _id: ACTIVITY_TYPE_TRAINING_ID,
    icon: 'training',
    label: ACTIVITY_TYPE_TRAINING,
    description: 'Activities that teach knowledge and skills',
    subTypes: [
        BASIC_MEDIATION,
        PEER_MEDIATION,
        REST_PRA,
        SKILL_BUILDING,
        ADVANCE_TRAINING,
        // MENTORING,
        CONFLICT_COUCHING_TRAINING,
        // PROF_LERNING_COM,
        OTHER_TRAINING,
    ],
};
